export default "__VITE_ASSET__CsVW_5lm__"